import { Component, computed, input, signal } from '@angular/core';
import { BaseFormControl, BaseSignalInput } from '@vallift/ngl';

@Component({
  selector: 'app-rating',
  imports: [BaseSignalInput],
  templateUrl: './rating.html',
  styleUrl: './rating.css',
  standalone:true
})
export class Rating extends BaseFormControl<number | null> {
  readonly label = input('');
  readonly helpText = input('');
  /** Lower bound of the numeric scale (ignored in star mode). */
  readonly scaleMin = input(1);
  /** Upper bound / star count. Stars render when this is ≤ 5. */
  readonly scaleMax = input(5);
  readonly lowLabel = input('');
  readonly highLabel = input('');

  readonly hoveredStar = signal<number | null>(null);

  readonly useStars = computed(() => this.scaleMax() <= 5);

  readonly scaleValues = computed(() => {
    if (this.useStars()) {
      return Array.from({ length: this.scaleMax() }, (_, index) => index + 1);
    }

    const min = this.scaleMin();
    const max = this.scaleMax();
    const length = Math.max(0, max - min + 1);
    return Array.from({ length }, (_, index) => min + index);
  });

  readonly showEndpointLabels = computed(
    () => !this.useStars() && (!!this.lowLabel() || !!this.highLabel()),
  );

  select(value: number): void {
    if (this.disabled() || this.readonly()) {
      return;
    }
    this.value.set(value);
  }

  isStarActive(star: number): boolean {
    const hover = this.hoveredStar();
    const current = this.value();

    if (hover !== null) {
      return star <= hover;
    }

    return current !== null && star <= current;
  }

  isButtonSelected(value: number): boolean {
    return this.value() === value;
  }

  onStarHover(star: number): void {
    if (this.disabled() || this.readonly()) {
      return;
    }
    this.hoveredStar.set(star);
  }

  onStarLeave(): void {
    this.hoveredStar.set(null);
  }
}
